import React, { useEffect } from 'react';
import CostUploadHistoryTable from '../../shared/CostUploadHistoryTable/CostUploadHistoryTable';
import { useUploadHistory } from "./CostUploadHistory.hooks";
import classes from "./CostUploadHistory.module.css";
const CostUploadHistory = () => {
    const { uploadHistory, page, setPage,  loading} = useUploadHistory();
    useEffect(() => {
        setPage(0);
    }, [setPage])
    return (
        <div>
            {/* <button data-testid='button-test-id'>Rest</button> */}
            
            <div className={classes.heading}>Cost Upload History</div>
            <CostUploadHistoryTable
                uploadHistory={uploadHistory}
                isPaginationRequired={true}
                currentPage={page}
                loading={loading}
            />
        </div>
    );
};

export default CostUploadHistory;
